import { warnImportMapViolation } from '../../internals/getSecurityHeaders'
warnImportMapViolation()
